var map = {
	"./bmp": 872,
	"./bmp.js": 872,
	"./gif": 873,
	"./gif.js": 873,
	"./jpg": 874,
	"./jpg.js": 874,
	"./png": 875,
	"./png.js": 875,
	"./psd": 876,
	"./psd.js": 876,
	"./svg": 877,
	"./svg.js": 877,
	"./tiff": 878,
	"./tiff.js": 878,
	"./webp": 879,
	"./webp.js": 879
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 870;


//////////////////
// WEBPACK FOOTER
// ./~/markdown-it-imsize/lib/imsize/types ^\.\/.*$
// module id = 870
// module chunks = 1